import React  from "react";

const FloatingLabelInput = ({ value,register, label, name, placeHolder, type, onChange,hasIcon,hasError,errorMessage,...inputProps }) => (
  
  <div className={`floating__label__content ${hasIcon?'input__group':''} ${hasError?'error__input':''}`}>
    {hasIcon?(
      <span className="input__group__prepend">
      <div className="input__group__text">$</div>
    </span>
    ):(null)}
    <input className="floating__input"
    // value={value}
    name={name}
    type={type} 
    ref={register}
    {...inputProps}
    onChange={onChange}
    placeholder=" "/>
    
    <label className="floating__label">{label}</label>
    {hasError?(
      <span className="error__message">{errorMessage}</span>
    ):(null)}
</div>
  
);

export default FloatingLabelInput;